// export default new AuthService();
import { authAPI } from '../api/auth';
import { subscriptionsAPI } from '../api/subscriptions';
import { dbHelpers } from '../db/database';
import syncService from './syncService';

class AuthService {
  async login(username, password) {
    try {
      const { access, refresh } = await authAPI.login(username, password);

      localStorage.setItem('access_token', access);
      localStorage.setItem('refresh_token', refresh);

      const user = await authAPI.getCurrentUser();

      if (process.env.NODE_ENV === 'development') {
        this.validateUserData(user);
      }

      localStorage.setItem('user', JSON.stringify(user));      
      
      // localStorage.setItem('user', JSON.stringify({
      //   id: user.id,
      //   username: user.username,
      //   email: user.email
      // }));

      const deviceId = await this.getOrCreateDeviceId();

      // ⭐ REGISTER DEVICE AND CHECK SUBSCRIPTION
      const deviceResponse = await subscriptionsAPI.registerDevice({
        device_id: deviceId,
        device_name: this.getDeviceName(),
        device_type: this.getDeviceType()
      });

      // ⭐ CRITICAL FIX: Check subscription properly
      let subscriptionExpired = true;

      if (deviceResponse.subscription) {
        const subInfo = deviceResponse.subscription.info || deviceResponse.subscription;

        // Check multiple fields to determine if valid
        const isAllowed = deviceResponse.subscription.allowed !== false; // undefined or true = allowed
        const isValid = subInfo.is_valid !== false;
        const daysRemaining = subInfo.days_remaining !== undefined ? subInfo.days_remaining : 0;

        // console.log('🔍 Subscription check:', {
        //   allowed: isAllowed,
        //   is_valid: isValid,
        //   days_remaining: daysRemaining
        // });

        // ⭐ Valid if any of these are true:
        // 1. explicitly allowed
        // 2. is_valid is true
        // 3. has days remaining > 0
        if (isAllowed || isValid || daysRemaining > 0) {
          subscriptionExpired = false;
        } else {
        }
      } else {
      }

      localStorage.setItem('subscription_expired', subscriptionExpired ? 'true' : 'false');

      // ⭐ ONLY SYNC IF SUBSCRIPTION IS VALID
      if (!subscriptionExpired && navigator.onLine) {
        syncService.fullSync().then(result => {
        }).catch(err => {
          console.error('❌ Sync failed:', err);
        });
      }
      

      return { success: true, user };
    } catch (error) {

      let errorMessage = 'Login failed';

      if (error.response && error.response.data) {
        if (error.response.data.non_field_errors) {
          errorMessage = error.response.data.non_field_errors[0];
        } else if (error.response.data.detail) {
          errorMessage = error.response.data.detail;
        } else if (error.response.data.error) {
          errorMessage = error.response.data.error;
        } else if (typeof error.response.data === 'string') {
          errorMessage = error.response.data;
        }
      } else if (error.message) {
        errorMessage = error.message;
      }

      return { success: false, error: errorMessage };
    }
  }

  async logout() {
    // Clear tokens
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    localStorage.removeItem('subscription_expired');

    // Clear offline data
    await dbHelpers.clearAllData();

    // Redirect to login
    window.location.href = '/login';
  }

  isAuthenticated() {
    return !!localStorage.getItem('access_token');
  }

  // isTokenExpired(token) {
  //   try {
  //     const payload = JSON.parse(atob(token.split('.')[1]));
  //     return payload.exp * 1000 < Date.now();
  //   } catch {
  //     return true;
  //   }
  // }
  
  // isAuthenticated() {
  //   const token = localStorage.getItem('access_token');
  //   if (!token) return false;
  //   if (this.isTokenExpired(token)) {
  //     this.logout();
  //     return false;
  //   }
  //   return true;
  // }
  
  getCurrentUser() {
    const userJson = localStorage.getItem('user');
    if (!userJson) return null;

    try {
      const user = JSON.parse(userJson);

      if (!user.groups) {
        user.groups = [];
      }

      return user;
    } catch (error) {
      return null;
    }
  }

  validateUserData(user) {
    if (!user) {
      return false;
    }

    const issues = [];

    // Required fields
    if (!user.username) issues.push('Missing username');
    if (!user.email) issues.push('Missing email');
    if (user.is_superuser === undefined) issues.push('Missing is_superuser');
    if (user.is_staff === undefined) issues.push('Missing is_staff');

    // CRITICAL: Check groups
    if (!user.groups) {
      issues.push('CRITICAL: Missing groups field!');
    } else if (!Array.isArray(user.groups)) {
      issues.push('CRITICAL: groups is not an array!');
    } else if (user.groups.length === 0) {
    } else {
      // Validate group structure
      const firstGroup = user.groups[0];
      if (typeof firstGroup === 'string') {
      } else if (firstGroup.name) {
      } else {
        issues.push('Invalid group format! Expected string or {name: "..."}');
      }
    }

    if (issues.length > 0) {
      issues.forEach(issue => console.error('  ❌', issue));
      return false;
    }
    return true;
  }

  async getOrCreateDeviceId() {
    let deviceId = localStorage.getItem('device_id');

    if (!deviceId) {
      // Check IndexedDB
      deviceId = await dbHelpers.getSetting('device_id');

      if (!deviceId) {
        // Generate new UUID
        deviceId = this.generateUUID();
      }

      localStorage.setItem('device_id', deviceId);
      await dbHelpers.setSetting('device_id', deviceId);
    }

    return deviceId;
  }

  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  getDeviceName() {
    const ua = navigator.userAgent;
    if (/Android/i.test(ua)) return 'Android Device';
    if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS Device';
    if (/Windows/i.test(ua)) return 'Windows PC';
    if (/Mac/i.test(ua)) return 'Mac';
    return 'Unknown Device';
  }

  getDeviceType() {
    const ua = navigator.userAgent;
    if (/Mobile/i.test(ua)) return 'mobile';
    if (/Tablet|iPad/i.test(ua)) return 'tablet';
    return 'desktop';
  }
}

export default new AuthService();
